import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { B as Box } from '../../Box/Box-0vVvo5bu.js';
import { b as basicMixin, c as checkedMixin, d as disabledMixin } from '../../Checkbox/Checkbox-BFixYUlg.js';
import { T as Text } from '../../Text/Text-nnmbpLTK.js';

const Main = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-0"
})(["display:flex;flex:1;align-items:flex-start;padding:", ";"], ({
  theme
}) => theme.spacing.medium);
const Body = /*#__PURE__*/styled(Text).attrs({
  type: 'p'
}).withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-1"
})(["text-align:start;font-size:", ";", ""], ({
  theme
}) => theme.typography.size.small, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.small)));
const rowChildMixin = /*#__PURE__*/css(["border-inline-start:1px solid ", ";border-inline-end:1px solid ", ";"], ({
  theme
}) => theme.button.toggleArea.borderColor, ({
  theme
}) => theme.button.toggleArea.borderColor);
const columnChildMixin = /*#__PURE__*/css(["border-block-start:1px solid ", ";border-block-end:1px solid ", ";"], ({
  theme
}) => theme.button.toggleArea.borderColor, ({
  theme
}) => theme.button.toggleArea.borderColor);
const childMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowChildMixin : columnChildMixin);
const Title = /*#__PURE__*/styled(Text).attrs({
  withMargin: false,
  type: 'p'
}).withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-2"
})(["text-align:start;", " ", ""], ({
  theme,
  $titleFontSize
}) => theme.typography[$titleFontSize === 'large' ? 'h4' : 'h5'], isMobile(css(["", ""], ({
  theme,
  $titleFontSize
}) => theme.typography.mobile[$titleFontSize === 'large' ? 'h4' : 'h5'])));
const TileControlTextContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-3"
})(["display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => theme.spacing.mini);
const rowContainerChildrenMixin = /*#__PURE__*/css(["border-inline-end:none;"]);
const columnContainerChildrenMixin = /*#__PURE__*/css(["border-block-end:none;"]);
const containerChildrenMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerChildrenMixin : columnContainerChildrenMixin);
const containerChildrenBorderRadiusMixin = /*#__PURE__*/css(["", ""], ({
  theme
}) => `calc(${theme.button.toggleArea.borderRadius} - 1px)`);
const rowContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-end-start-radius:", ";border-inline-start:none;"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const columnContainerFirstChildMixin = /*#__PURE__*/css(["border-start-start-radius:", ";border-start-end-radius:", ";border-block-start:none;"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const containerFirstChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerFirstChildMixin : columnContainerFirstChildMixin);
const rowContainerLastChildMixin = /*#__PURE__*/css(["border-start-end-radius:", ";border-end-end-radius:", ";"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const columnContainerLastChildMixin = /*#__PURE__*/css(["border-end-start-radius:", ";border-end-end-radius:", ";"], containerChildrenBorderRadiusMixin, containerChildrenBorderRadiusMixin);
const containerLastChildMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowContainerLastChildMixin : columnContainerLastChildMixin);
const rowChildHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  $hideStartBorder
}) => $hideStartBorder && css(["border-inline-start:none;"]));
const columnChildHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  $hideStartBorder
}) => $hideStartBorder && css(["border-block-start:none;"]));
const childHideBorderMixin = /*#__PURE__*/css(["", ""], ({
  $direction
}) => $direction === 'row' ? rowChildHideBorderMixin : columnChildHideBorderMixin);
const focusMixin = /*#__PURE__*/css([":has(:focus-visible){", "}@supports not selector(:focus-visible){", "}"], focusOutline, focusOutline);
const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-4"
})(["overflow-x:auto;", ";background-color:", ";border:1px solid ", ";border-radius:", ";color:", ";user-select:auto;display:flex;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,border-color 100ms ease;}", " ", " ", " flex-direction:", ";", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.button.toggleArea.bg, ({
  theme
}) => theme.button.toggleArea.borderColor, ({
  theme
}) => theme.button.toggleArea.borderRadius, ({
  theme
}) => theme.button.toggleArea.color, isMobile(css(["", ";flex:1;"], ({
  theme
}) => theme.typography.mobile.base)), ({
  $checked
}) => $checked && css(["border:1px solid ", ";box-shadow:0 0 0 1px ", ";"], ({
  theme
}) => theme.button.toggleArea.borderColorActive, ({
  theme
}) => theme.button.toggleArea.borderColorActive), ({
  $disabled
}) => $disabled && css(["pointer-events:all;cursor:not-allowed;outline:none;opacity:1;color:", ";"], ({
  theme
}) => theme.typography.color.tertiary), ({
  $direction
}) => $direction === 'row' ? 'row' : 'column', ({
  $focusVisible
}) => $focusVisible && focusMixin);
const SubText = /*#__PURE__*/styled(Text).attrs({
  type: 'p'
}).withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-5"
})(["text-align:start;font-size:", ";", " color:", ";"], ({
  theme
}) => theme.typography.size.small, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.small)), ({
  theme
}) => theme.palette.gray[700]);
const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-6"
})(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.small);
const Checkbox = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-7"
})(["", " appearance:none;margin:0;margin-block-start:2px;margin-inline-end:", ";", " ", ""], basicMixin, ({
  theme
}) => theme.spacing.small, ({
  $checked
}) => $checked && checkedMixin, ({
  $disabled
}) => $disabled && disabledMixin);
const ChildBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-30060407__sc-u3bskh-8"
})(["border-radius:initial;", " ", " ", " :first-of-type{", "}:last-of-type{", "}"], childMixin, childHideBorderMixin, containerChildrenMixin, containerFirstChildMixin, containerLastChildMixin);

export { Body as B, Container as C, IconWrapper as I, Main as M, SubText as S, TileControlTextContainer as T, ChildBox as a, Checkbox as b, Title as c };
//# sourceMappingURL=Tile.styles-DKH85JkM.js.map
